import { LoggerActions, LoggerLog, Log, LoggerClearLog, SetLogLevel } from '@app/core/store/actions/logger.actions';
import { LogMessage } from '@app/core/models/log-message';

/**
 * level: 7 - debug, 6 - informational, 5 - notice, 4 - warn
 *        3 - error, 2 - critical, 1 - alert, 0 - emergency
 */
export interface State {
  level: number;
  messageQueue: LogMessage[];
}

export const initialState: State = {
  level: 6,
  messageQueue: []
};

export function reducer(state = initialState, action: typeof LoggerActions): State {
  switch (action.type) {
    case LoggerLog.type: {
      if (action.logMessage.level > state.level) {
        return state;
      }

      return {
        ...state,
        messageQueue: [...state.messageQueue, action.logMessage]
      };
    }

    case Log.type: {
      if (action.level > state.level) {
        return state;
      }

      return {
        ...state,
        messageQueue: [...state.messageQueue, new LogMessage(action)]
      };
    }

    case LoggerClearLog.type: {
      return { ...state, messageQueue: [] };
    }

    case SetLogLevel.type: {
      return { ...state, level: action.level };
    }

    default:
      return state;
  }
}

export const selectMessageQueue = (state: State) => state.messageQueue;
export const selectLevel = (state: State) => state.level;
